import { Row, Col, Card, Form } from 'react-bootstrap';


import './styles.css'

export default function SupplyCategories(props) {
    const {
        supplies,
        handleAddSuppliesForOrder
    } = props;

    const preventMinus = (e) => {
        if (e.key === '-' || e.key === ' ' || (e.key.length === 1 && !/[0-9]/.test(e.key))) {
            e.preventDefault();
        }
    };

    const suppliesToShow = supplies.filter(x =>
        x.supplyCategory !== 'Soil Probe Equipment' &&
        x.supplyCategory !== 'Hay Probe Equipment' &&
        x.supplyCategory !== 'Other Equipment'
    );

    return (
        <>
            {suppliesToShow.map((item, index) =>
                <Col xs={12} sm={12} md={6} lg={6} xl={4} className="card-col" key={index}>
                    <Row>
                        <span>
                            &nbsp;&nbsp;&nbsp;<b className="bold-subheading extrabold">{item.supplyCategory}</b>
                        </span>
                        <Card className="supplies-card">
                            {item.supplies.map((card, supplyIndex) =>
                                <Row className='card-supplies-row' key={supplyIndex}>
                                    <Col xs={12} className="supplies-descriptions">
                                        <p className='order-items info-labels'>
                                            {card.supplyName} &nbsp;
                                            {card.supplyDescription}
                                        </p>
                                    </Col>
                                    <Col xs={3} sm={3} md={3} lg={2} xl={2}>
                                        <Form.Control
                                            className="quantity-input"
                                            type="number"
                                            min="0"
                                            placeholder="0"
                                            size="sm"
                                            style={{ fontWeight: "bold", fontSize: "18px" }}
                                            onKeyDown={preventMinus}
                                            onChange={e => handleAddSuppliesForOrder(e, card, item.supplyCategory)}
                                        />
                                    </Col>
                                    <p></p>
                                </Row>
                            )}
                            {item.supplyCategory === 'Water Sampling Supplies' &&
                                <Row className="wtr-sup-mssg-row">
                                    <span className='wtr-sup-mssg'>
                                        <b>Call Lab For Special Request</b>
                                    </span>
                                </Row>
                            }
                        </Card>
                    </Row>
                </Col>
            )}
        </>
    )

}
